// extracted by mini-css-extract-plugin
export var activeFilterButton = "_jm-c";
export var backButton = "_jm-4";
export var backIcon = "_jm-5";
export var chevronShortcut = "_jm-6";
export var container = "_jm-1";
export var editor = "_jm-8";
export var editorWrapper = "_jm-7";
export var prefix = "_jm-2";
export var searchIcon = "_jm-3";
export var suffix = "_jm-9";
export var suffixContent = "_jm-a";
export var suffixText = "_jm-b";
export var wrapper = "_jm-0";